/**
 * Utility functions for PayPal and PayPal.Me pre-filled URLs
 */

export function getPayPalMeUrl(
  rawLink?: string,
  amountBrl?: number,
  currency: string = 'BRL'
): string {
  const defaultBase = 'https://www.paypal.com/paypalme/dojapaotasuacasa';
  let link = (rawLink && rawLink.trim().length > 0) ? rawLink.trim() : defaultBase;

  // If user entered just a username like 'dojapaotasuacasa' or '@dojapaotasuacasa'
  if (!link.startsWith('http://') && !link.startsWith('https://')) {
    const cleanUsername = link.replace(/^@/, '').trim();
    link = `https://www.paypal.com/paypalme/${cleanUsername}`;
  }

  // Normalize paypal.me or paypal.com/paypalme
  // Remove any trailing slashes
  link = link.replace(/\/+$/, '');

  // Strip any existing trailing amount path (e.g. /150.00BRL, /50USD, /100)
  link = link.replace(/\/\d+(?:\.\d+)?(?:[a-zA-Z]{3})?$/i, '');

  if (amountBrl !== undefined && amountBrl !== null && !isNaN(amountBrl) && amountBrl > 0) {
    // PayPal.me format: https://www.paypal.com/paypalme/USERNAME/150.00BRL
    const formattedAmount = Number(amountBrl).toFixed(2);
    return `${link}/${formattedAmount}${currency.toUpperCase()}`;
  }

  return link;
}

export function extractPayPalUsername(rawLink?: string): string {
  if (!rawLink) return 'dojapaotasuacasa';
  const clean = rawLink
    .replace(/^https?:\/\/(?:www\.)?paypal\.(?:com\/paypalme|me)\//i, '')
    .replace(/\/.*$/, '')
    .replace(/^@/, '')
    .trim();
  return clean || 'dojapaotasuacasa';
}
